import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';

import { Pagination, paginationMaxTake } from '@shared/client/models/pagination.model';

//This interface is used to be ISO with what generate the sdk for parameters
//it used for typing ParamsType, that way I can pass every parameter generated by the sdk
//for get query
export interface PaginationSdkParams {
    isCaseSensitive?: boolean;
    order?: 'DESC' | 'ASC';
    orderBy?: string;
    page?: number;
    take?: number;
    totalItems?: number;
}

export interface FilterParams {
    properties?: string[];
    value?: string;
}

@Injectable({
    providedIn: 'root',
})
export class FetchAllService {
    public async getAll<ParamsType extends PaginationSdkParams & FilterParams, T>(
        getPaginatedItems: (params: ParamsType) => Observable<Pagination<T>>,
        parameters: ParamsType,
        report?: (delta: number) => void,
    ): Promise<T[]> {
        const items: T[] = [];
        let page = 0;
        let hasNextPage = false;

        do {
            const response = await firstValueFrom(
                getPaginatedItems({ ...parameters, page: page, take: paginationMaxTake }),
            );

            items.push(...response.items);
            page += 1;
            hasNextPage = response.hasNextPage;

            report?.(response.items.length);
        } while (hasNextPage);

        return items;
    }
}
